"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tippy = _interopRequireDefault(require("tippy.js"));
var _constants = require("../../constants");
require("tippy.js/dist/tippy.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LabelTooltip = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LabelTooltip, _React$Component);
  var _super = _createSuper(LabelTooltip);
  function LabelTooltip() {
    (0, _classCallCheck2["default"])(this, LabelTooltip);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(LabelTooltip, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement("span", {
        ref: function ref(span) {
          _this.span = span;
        },
        title: this.props.text,
        "aria-label": this.props.text,
        className: this.props.className,
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          display: 'inline-block'
        })
      }, this.props.children));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tippy = new _tippy["default"](this.span, {
        arrow: true,
        position: this.props.position,
        animation: 'fade',
        duration: 200,
        theme: this.props.theme,
        hideOnClick: this.props.hideOnClick,
        html: this.props.tippyHtml,
        trigger: this.props.trigger,
        interactive: this.props.interactive
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.tippy) {
        return;
      }
      var popper = this.tippy.getPopperElement(this.span);
      this.tippy.update(popper);
      if (this.props.trigger === 'manual' && prevProps.manualShow !== this.props.manualShow) {
        this.props.manualShow ? this.tippy.show(popper) : this.tippy.hide(popper);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.tippy) {
        return;
      }
      var popper = this.tippy.getPopperElement(this.span);
      this.tippy.destroy(popper);
    }
  }]);
  return LabelTooltip;
}(React.Component);
(0, _defineProperty2["default"])(LabelTooltip, "propTypes", {
  text: _propTypes["default"].string.isRequired,
  position: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  theme: _propTypes["default"].string,
  hideOnClick: _propTypes["default"].bool,
  tippyHtml: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].instanceOf(Element)]),
  manualShow: _propTypes["default"].bool,
  trigger: _propTypes["default"].string,
  // one or more of: ['mouseenter', 'focus', 'click', 'manual']
  interactive: _propTypes["default"].bool,
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(LabelTooltip, "defaultProps", {
  position: 'bottom',
  theme: 'default',
  hideOnClick: true,
  tippyHtml: false,
  manualShow: false,
  trigger: 'mouseenter focus',
  style: {},
  interactive: false
});
var GlobalStyle = (0, _styledComponents.createGlobalStyle)([".tippy-popper{", "}"], (0, _constants.fontWeight)('heavy'));